import * as React from 'react';
import * as Constants from 'src/constants';
import * as Layout from 'src/components/Layout';
import Image from 'next/image';
import Text from 'src/components/Text';
import moment from 'moment-timezone';
import { StyleSheet, View } from 'react-native';

type AuthorType = 'Albert Chuang' | 'Ryan Hill' | 'OneShop Team' | 'Ryan Lucia';

const AUTHORS: {
  [key in AuthorType]: {
    name: string;
    imageUrl: string;
  };
} = {
  'Albert Chuang': {
    name: 'Albert Chuang',
    imageUrl: '/static/images/blog/author/albert1.jpg',
  },
  'Ryan Hill': {
    name: 'Ryan Hill',
    imageUrl: '/static/images/blog/author/ryan1.jpg',
  },
  'OneShop Team': {
    name: 'OneShop Team',
    imageUrl: '/static/images/blog/author/oneshop2.png',
  },
  'Ryan Lucia': {
    name: 'Ryan Lucia',
    imageUrl: '/static/images/blog/author/ryan2.jpg',
  },
};

interface PropsIface {
  author: AuthorType;
  dateTime: string;
  tag: string;
  title: string;
}

const BlogPage: React.FC<PropsIface> = (props) => {
  const blogContentRootRef = React.useRef<HTMLElement>(null);
  const [readingDuration, setReadingDuration] = React.useState<number>(1);

  React.useEffect(() => {
    const blogContentRoot = blogContentRootRef.current;
    if (blogContentRoot != null) {
      setReadingDuration(Math.ceil(blogContentRoot.innerText.split(/\s+/g).length / 238));
    }
  }, []);

  const formattedDateLabel: string = React.useMemo(() => {
    return moment(props.dateTime).tz('America/Los_Angeles').format('MMM DD, YYYY');
  }, [props.dateTime]);
  return (
    <View style={styles.root}>
      <Layout.EdgeGutter style={styles.column}>
        <Text style={[Constants.TextStyle.T16M, Constants.TextStyle.CBolt]}>{props.tag.toUpperCase()}</Text>
        <Text style={[Constants.TextStyle.T42B, Constants.GridStyle.MB2Unit]}>{props.title}</Text>
        <View
          style={{
            flexDirection: 'row',
          }}
        >
          <View
            style={{
              width: Constants.Grid.dp(36),
              height: Constants.Grid.dp(36),
              borderRadius: Constants.Grid.dp(18),
              overflow: 'hidden',
              marginRight: Constants.Grid.dp(12),
            }}
          >
            <Image
              src={AUTHORS[props.author].imageUrl}
              width={128}
              height={128}
              alt={`Photo of ${AUTHORS[props.author].name}`}
            />
          </View>
          <View
            style={{
              justifyContent: 'center',
            }}
          >
            <Text style={[Constants.TextStyle.T12M]}>{AUTHORS[props.author].name}</Text>
            <Text style={[Constants.TextStyle.T12R, Constants.TextStyle.CDarkGray]}>
              <time dateTime={props.dateTime}>{formattedDateLabel}</time> <span aria-hidden='true'>&middot;</span>{' '}
              <span>{readingDuration} min read</span>
            </Text>
          </View>
        </View>
        <main id='blog-content-root' ref={blogContentRootRef}>
          {props.children}
        </main>
      </Layout.EdgeGutter>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    alignItems: 'center',
    paddingTop: 6 * Constants.Grid.dp(12),
  },
  column: {
    width: Constants.Grid.dp(760),
    maxWidth: '100%',
  },
});

export default BlogPage;
